import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { useTranslation, withTranslation } from 'react-i18next';
import {
    FormGroup,
    FormGroupSelect,
    FormGroupTextarea,
    Button, FormGroupCheckbox,
} from '@paysera/react-common';
import FormGroupDropZone from '@assetsJsModule/dropzone';
import getFileSizeNotice from '@assetsJsModule/dropzone/service/getFileSizeNotice';
import { PrivacyPolicyAgency } from '../../shared/components';
import { FORM_VACANCY_NAMES } from '../config/constants';
import {
    ENGLISH_LEVEL_OPTIONS,
    COUNTRIES_OPTIONS,
    ALLOWED_MIME_TYPES,
    MAX_FILE_SIZE,
    COLUMN_GRID_COUNT,
    MAX_NUMBERS_OF_FILES,
    MAX_TOTAL_FILES_SIZE
} from '../../shared/config/constants';
import validate from '../utils/agencyApplyFormValidateon';

const AgencyApplyForm = ({
    handleSubmit,
    onSubmit,
}) => {
    const { t } = useTranslation('PayseraRecruitmentBundle');

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup
                name={FORM_VACANCY_NAMES.FIRST_NAME}
                label={t('apply_form.first_name')}
                type="text"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.LAST_NAME}
                label={t('apply_form.last_name')}
                type="text"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.EMAIL}
                label={t('apply_form.email')}
                type="email"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.PHONE}
                label={t('apply_form.phone')}
                type="phone"
                classConfig={{ label: 'required' }}
            />
            <FormGroupSelect
                name={FORM_VACANCY_NAMES.ENGLISH_LEVEL}
                options={ENGLISH_LEVEL_OPTIONS}
                label={t('apply_form.english_level')}
                classConfig={{ label: 'required' }}
            />
            <FormGroupSelect
                name={FORM_VACANCY_NAMES.COUNTRY}
                options={COUNTRIES_OPTIONS}
                label={t('apply_form.country_of_residence')}
                classConfig={{ label: 'required' }}
            />
            <div className="form-group">
                <FormGroupDropZone
                    name={FORM_VACANCY_NAMES.CV}
                    label={t('apply_form.resume_cv')}
                    contentBase64Encoded
                    maxFileSizeMB={MAX_FILE_SIZE}
                    maxTotalFilesSizeMB={MAX_TOTAL_FILES_SIZE}
                    maxTotalFilesCount={MAX_NUMBERS_OF_FILES}
                    columnGridCount={COLUMN_GRID_COUNT}
                    notice={getFileSizeNotice(MAX_FILE_SIZE, MAX_NUMBERS_OF_FILES)}
                    allowedMimeTypes={ALLOWED_MIME_TYPES}
                />
            </div>
            <FormGroup
                name={FORM_VACANCY_NAMES.LINKEDIN}
                label={t('apply_form.links')}
                type="url"
            />
            <FormGroupTextarea
                name={FORM_VACANCY_NAMES.INFORMATION}
                label={t('apply_form.additional_information')}
            />
            <FormGroupTextarea
                name={FORM_VACANCY_NAMES.SUBMIT_TASK}
                label={t('apply_form.submit_task')}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.NAME_OF_AGENCY}
                label={t('apply_form.name_agency')}
                type="text"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.AGENCY_ID}
                label={t('apply_form.agency_ID')}
                type="text"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.AGENCY_EMAIL}
                label={t('apply_form.agency_email')}
                type="email"
                classConfig={{ label: 'required' }}
            />
            <FormGroup
                name={FORM_VACANCY_NAMES.CONTACT_PERSON}
                label={t('apply_form.contact_person')}
                type="text"
                classConfig={{ label: 'required' }}
            />
            <FormGroupTextarea
                name={FORM_VACANCY_NAMES.AGENCY_FEEDBACK}
                label={t('apply_form.feedback')}
            />
            <FormGroupCheckbox
                name={FORM_VACANCY_NAMES.PRIVACY_POLICY}
                label={<PrivacyPolicyAgency />}
                classConfig={{ label: 'required' }}
            />
            <div className="form-group">
                <Button type="submit" bsStyle="primary">
                    Submit
                </Button>
            </div>
        </form>
    );
};

AgencyApplyForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default compose(
    withTranslation('validators'),
    reduxForm({
        form: 'vacancy',
        validate,
        destroyOnUnmount: false,
    }),
)(AgencyApplyForm);
